import { render } from "./LanguageDialog.vue?vue&type=template&id=26e137f2"
import script from "./LanguageDialog.vue?vue&type=script&lang=js"
export * from "./LanguageDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__